// Calcul unique de la complétion du wizard bien — utilisé par le CompletionBar (étapes 1-5)
// ET par Step6_Summary. Garantit un score cohérent du début à la fin du wizard.

export const calculateWizardCompletion = (data = {}) => {
  let score = 0;

  // Étape 1 — Taxonomie (20%) : progression fine, 4% par champ
  if (data.operation) score += 4;
  if (data.objet) score += 4;
  if (data.profil) score += 4;
  if (data.sous_profil) score += 4;
  if (data.cible) score += 4;

  // Étape 2 — Pack (5%) : optionnel mais compte si rempli
  if (data.is_pack !== undefined && data.is_pack !== null) score += 3;
  if (data.is_pack && data.pack_type) score += 2;

  // Étape 3 — Infos clés (30%) : localisation + données financières + surface
  if (data.ville) score += 7;
  if (data.code_postal) score += 7;

  // Données financières — adaptatif selon l'opération
  const hasFinancialData = data.operation === 'location_droit_entree'
    ? (data.droit_entree && data.loyer_mensuel)
    : (data.prix || data.loyer || data.loyer_mensuel);
  if (hasFinancialData) score += 10;

  if (data.surface_totale_m2) score += 6;

  // Étape 4 — Contact Propriétaire (15%)
  if (data.contact_proprietaire_id || (data.nouveau_contact?.nom && data.nouveau_contact?.prenom)) {
    score += 15;
  }

  // Étape 5 — Mandat (15%)
  if (data.numero_mandat) score += 8;
  if (data.negociateur) score += 4;
  if (data.date_mandat) score += 3;

  // Médias (10%)
  if (data.photos?.length > 0) score += 5;
  if (data.documents?.length > 0) score += 5;

  // Autres (5%) — Description, secteur, charges
  if (data.description_courte) score += 3;
  if (data.secteur) score += 1;
  if (data.charges) score += 1;

  return Math.min(score, 100);
};
